import { FC } from 'react';
import { ToastVariant } from './BPToast';
import { cn } from 'lib/utils';
import { uiSimpleBox } from '../CutCorners';
import BPIcon from '../icons/BPIcon';

interface ToastIconProps {
  variant: ToastVariant;
}

const IconBox: FC<{ border: string; bg: string; icon: JSX.Element }> = ({
  border,
  bg,
  icon,
}) => (
  <div
    className={cn(
      'grid relative w-[48px] h-[48px] place-content-center',
      bg,
      uiSimpleBox.bg
    )}
  >
    <div
      className={cn('grid absolute w-full h-full', border, uiSimpleBox.border)}
    />
    {icon}
  </div>
);

const icons = {
  success: (
    <IconBox
      border="bg-gradient-to-b from-bionic-green/50 to-bionic-green/20"
      bg="bg-gradient-to-b from-bionic-green/20 to-bionic-green/10"
      icon={<BPIcon icon="check" className="fill-bionic-green scale-[1.3]" />}
    />
  ),
  error: (
    <IconBox
      border="bg-gradient-to-b from-[#FC3838]/50 to-[#FC3838]/20"
      bg="bg-gradient-to-b from-[#FC3838]/20 to-[#FC3838]/10"
      icon={<BPIcon icon="error" className="fill-[#FC3838] animate-pulse" />}
    />
  ),
  spinner_blue: (
    <IconBox
      border="bg-gradient-to-b from-[#0BB4FF]/50 to-[#0BB4FF]/20"
      bg="bg-gradient-to-b from-[#0BB4FF]/20 to-[#0BB4FF]/10"
      icon={<BPIcon icon="spinner" className="fill-[#0BB4FF] animate-spin" />}
    />
  ),
  spinner_orange: (
    <IconBox
      border="bg-gradient-to-b from-[#FC7038]/50 to-[#FC7038]/20"
      bg="bg-gradient-to-b from-[#FC7038]/20 to-[#FC7038]/10"
      icon={<BPIcon icon="spinner" className="fill-[#FC7038] animate-spin" />}
    />
  ),
};

const ToastIcon: FC<ToastIconProps> = ({ variant }) => icons[variant];
export default ToastIcon;
